import React, {useEffect, useContext} from 'react';
import {ViewDataContext} from '../../commons/context/view/ViewDataContext';
import SDDwellingDataUI from "./SDDwellingDataUI";
import {FiltersStateContext} from "../../commons/context/FiltersStateContext";
import {FiltersDataContext} from '../../commons/context/FiltersDataContext';
import {getRefreshInterval} from "../../util/CommonUtils";

export const SDDwellingData = () => {

    const {viewModel, dispatch} = useContext(ViewDataContext)
    const {selectedFilterValues} = useContext(FiltersStateContext)
    const {filtersData} = useContext(FiltersDataContext)
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let stationCode = params.get('stationCode');

    useEffect(() => {

        constructState();
        dispatch({ type: 'LOAD_VIEW', data:{filters: selectedFilterValues , stationCode, view : "SD_DWELLING_VIEW" ,dispatcher: dispatch, leg:"FORWARD", isCPTFilter: false}});
        const interval = setInterval(() => {
            constructState();
            //check for inactive tabs
            if ( !document.hidden)
            {
                dispatch({ type: 'LOAD_VIEW', data:{filters: selectedFilterValues , stationCode, view : "SD_DWELLING_VIEW" ,dispatcher: dispatch, leg:"FORWARD", isCPTFilter: false}});
            }
        }, getRefreshInterval());
        return () => clearInterval(interval);}, []);

    return (
        <SDDwellingDataUI data = {viewModel.metricResult} stationTimeZone = {viewModel.stationTimeZone} isLoading = {viewModel.isLoading}
                        appliedFilterURL = { selectedFilterValues.appliedFilterURL} filterData= {filtersData}/>
    )
}

const constructState = () => {

    var values = {
    }
    //Redirect to search path
    var path = window.location.href.split("dwellingBoard")[0];
    return window.location.replace( path + "dwellingBoard/sd/"+ JSON.stringify(values).replace('/','%2f'));
}


// WEBPACK FOOTER //
// ./src/components/sdDwelling/SDDwellingData.js